import {
  parsePsePayer,
  PSE_MODES,
  PSE_PAYMENT_METHOD_ID,
  PSE_RETURN_PARAM,
  pseIdTypeFromBilling,
  type PseAddress,
  type PseReturnKind,
} from "../../supabase/functions/mercadopago-direct-payment/pse";

export { parsePsePayer, PSE_PAYMENT_METHOD_ID, PSE_RETURN_PARAM, pseIdTypeFromBilling, type PseAddress, type PseReturnKind };

export interface PsePaymentInput {
  financial_institution: string;
  entity_type: string;
  identification: { type: string; number: string };
  first_name: string;
  last_name: string;
  phone: string;
  address: PseAddress;
}

export function isPseMode(mode: string | null | undefined): boolean {
  return !!mode && PSE_MODES.has(mode);
}

export type PseSettlement = "approved" | "failed" | "pending";

const FAILED_STATUSES = new Set(["rejected", "cancelled", "refunded", "charged_back"]);

export function pseSettlement(status: string | null | undefined): PseSettlement {
  if (status === "approved") return "approved";
  if (status && FAILED_STATUSES.has(status)) return "failed";
  return "pending";
}

export function readPseReturn(search: string): { kind: PseReturnKind; paymentId: string | null } | null {
  const params = new URLSearchParams(search);
  const kind = params.get(PSE_RETURN_PARAM);
  if (kind !== "topup") return null;
  const paymentId = params.get("payment_id");
  return { kind, paymentId: paymentId && /^\d{1,20}$/.test(paymentId) ? paymentId : null };
}

export function withoutPseReturn(search: string): string {
  const params = new URLSearchParams(search);
  params.delete(PSE_RETURN_PARAM);
  params.delete("payment_id");
  const rest = params.toString();
  return rest ? `?${rest}` : "";
}

export interface PseContact {
  first_name: string;
  last_name: string;
  phone: string;
  street_name: string;
  street_number: string;
  neighborhood: string;
  city: string;
  federal_unit: string;
  zip_code: string;
}

export type PseBrickFormData = {
  transaction_details?: { financial_institution?: string };
  payer?: { entity_type?: string; identification?: { type?: string; number?: string } };
};

export function pseInputFrom(contact: PseContact, formData: PseBrickFormData): PsePaymentInput {
  return {
    financial_institution: String(formData.transaction_details?.financial_institution ?? ""),
    entity_type: String(formData.payer?.entity_type ?? ""),
    identification: {
      type: String(formData.payer?.identification?.type ?? ""),
      number: String(formData.payer?.identification?.number ?? ""),
    },
    first_name: contact.first_name,
    last_name: contact.last_name,
    phone: contact.phone,
    address: {
      zip_code: contact.zip_code,
      street_name: contact.street_name,
      street_number: contact.street_number,
      neighborhood: contact.neighborhood,
      city: contact.city,
      federal_unit: contact.federal_unit,
    },
  };
}
